import { c as _c } from "react/compiler-runtime";
import { MatchTabbedList } from "@/views/home/partials/matches/MatchTabbedList";
import type { FUSportsMatchWithNativeId } from "@/utilities/data/types";
interface MatchesSectionProps {
  matches: FUSportsMatchWithNativeId[];
}

/**
 * Thin wrapper around the site's own `MatchTabbedList` — the same component
 * used on every competition/team home. Splits a flat list into upcoming
 * (LIVE + NOT_STARTED) and finished, matching the classic layout's rule.
 */
export function MatchesSection(t0) {
  const $ = _c(7);
  const {
    matches
  } = t0;
  let t1;
  if ($[0] !== matches) {
    t1 = matches.filter(_temp).sort(_temp2).slice(0, 10);
    $[0] = matches;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const finishedMatches = t1;
  let t2;
  if ($[2] !== matches) {
    t2 = matches.filter(_temp3).sort(_temp4).slice(0, 10);
    $[2] = matches;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const upcomingMatches = t2;
  let t3;
  if ($[4] !== finishedMatches || $[5] !== upcomingMatches) {
    t3 = <MatchTabbedList upcomingMatches={upcomingMatches} finishedMatches={finishedMatches} />;
    $[4] = finishedMatches;
    $[5] = upcomingMatches;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp4(a_0, b_0) {
  return new Date(a_0.timing.kickoffTime).getTime() - new Date(b_0.timing.kickoffTime).getTime();
}
function _temp3(m_0) {
  const t = m_0.status?.type;
  return t === "LIVE" || t === "NOT_STARTED" || t === undefined;
}
function _temp2(a, b) {
  return new Date(b.timing.kickoffTime).getTime() - new Date(a.timing.kickoffTime).getTime();
}
function _temp(m) {
  return m.status?.type === "FINISHED";
}